export default {
  nav_home: 'Inicio',
  nav_guide: 'Guía de USFans Spreadsheet',
  nav_shopping_guide: 'Guía de compras',
  nav_categories: 'Categorías',
  nav_browse: 'Explorar categorías',
  lang_label: 'Idioma',
  footer_tagline: 'Un centro independiente y organizado de recursos, guías y consejos de seguridad sobre USFans Spreadsheet.',
  footer_categories: 'Categorías',
  footer_resources: 'Recursos',
  footer_guide: 'Guía de USFans Spreadsheet',
  footer_home: 'Inicio',
  footer_disclaimer: 'Este es un sitio web de información independiente y no es el sitio web oficial de USFans.',
  footer_rights: 'Todos los derechos reservados.',
  footer_visit_main: 'Visitar el sitio web principal',
};